import { gql } from "@apollo/client";

export const GET_PERSONAL_API_KEYS = gql`
  query GetPersonalApiKeys {
    viewer {
      apiKeys {
        id
        createdAt
        description
        admin
        teams
        type
        teamCount
        lastUsedAt
        name
        spaceCount
        accessRules {
          space
          spaceAccessLevel
        }
        oidcSettings {
          clientId
          issuer
          subjectExpression
        }
      }
    }
    seats {
      apiKey {
        limit
        inUse
      }
    }
  }
`;
